import { FieldType } from './field-type.enum';
import {
  JsonConverter,
  JsonCustomConvert,
  JsonObject,
  JsonProperty
} from 'json2typescript';
import { RadioOption } from './radio-option';



@JsonConverter
export class FieldNameConverter implements JsonCustomConvert<string> {
  serialize(name: string): any {
    return name;
  }

  deserialize(name: string): string {
    return name.indexOf('::') !== -1 ? name.split('::')[0] : name;
  }
}

@JsonConverter
export class OptionsConverter implements JsonCustomConvert<Set<RadioOption>> {
  serialize(options: Set<RadioOption>): any {
    return options;
  }

  deserialize(fieldName: any): Set<RadioOption> {
    let options = fieldName.split('::')[1] ? fieldName.split('::')[1].split('|||') : [];
    let radioOptions: Set<RadioOption> = new Set();
    options.forEach(option => radioOptions.add(new RadioOption(option)));
    return radioOptions;
  }
}

@JsonObject
export class Field {
  @JsonProperty('id', Number)
  id: number = undefined;
  @JsonProperty('idx', Number)
  idx: number = undefined;
  @JsonProperty('type', String)
  type: FieldType = FieldType.TEXT;
  @JsonProperty('required', Boolean)
  required: boolean = undefined;

  /**
   * å­æ®µåï¼åç«¯ä½¿ç¨ï¼åç«¯ä¸ç´æ¥ä½¿ç¨ï¼è¯·ä½¿ç¨fieldName
   */
  @JsonProperty('name', String)
  private name: string = undefined;
  // setterä¾åºååæ¶ä½¿ç¨ï¼ä¸æä¾getter
  set theName(name) {
    this.name = name;
  }

  /**
   * å­æ®µç¸å³é¡¹ï¼å¯æ©å±ï¼
   */
  @JsonProperty('name', OptionsConverter)
  options: Set<RadioOption> = new Set();

  /**
   * å­æ®µåï¼åç«¯è®¿é®
   */
  @JsonProperty('name', FieldNameConverter)
  fieldName: string = undefined;

  /**
   * æåº
   */
  sort?: boolean = undefined;

  constructor() {
    this.id = 0;
    this.idx = 1;
    this.name = '';
    this.fieldName = '';
  }

  /**
   * å¤æ­å¯¹è±¡æ¯å¦ä¸ºç©º
   */
  public isEmpty(): boolean {
    return !this.fieldName;
  }

  /**
   * äº¤æ¢
   * @param idx1 ä½ç½®1
   * @param idx2 ä½ç½®2
   */
  public exchangeOption(idx1: number, idx2: number) {
    let options = Array.from(this.options);
    if (!options[idx1] || !options[idx2]) {
      return;
    }

    let option = options[idx1];
    options[idx1] = options[idx2];
    options[idx2] = option;

    this.options = new Set(options);
  }
}
